export const GROUP_STATUS_LABELS = { draft: '草稿', issued: '已出单', voided: '已作废' } as const
export const GROUP_STATUS_COLORS = { draft: 'gold', issued: 'green', voided: 'red' } as const

export const GROUP_SETTLEMENT_LABELS = { settled: '全部已结算', partial: '部分结算', unsettled: '尚未结算' } as const
export const GROUP_SETTLEMENT_COLORS = { settled: 'green', partial: 'blue', unsettled: 'default' } as const
